import React from 'react';
import { Link } from 'react-router-dom';
import AnimatedSection from '../components/AnimatedSection';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>A successful business starts with a website.</h1>
            <Link to="/contact" className="cta-button">Get Started</Link>
          </div>
          <div className="website-showcase">
            <div className="showcase-grid">
              <div className="showcase-item showcase-1">
                <div className="mock-website">
                  <div className="mock-header"></div>
                  <div className="mock-content">
                    <div className="mock-text-line"></div>
                    <div className="mock-text-line short"></div>
                    <div className="mock-button"></div>
                  </div>
                </div>
              </div>
              <div className="showcase-item showcase-2">
                <div className="mock-website dark">
                  <div className="mock-header dark"></div>
                  <div className="mock-content">
                    <div className="mock-text-line light"></div>
                    <div className="mock-text-line light short"></div>
                    <div className="mock-button orange"></div>
                  </div>
                </div>
              </div>
              <div className="showcase-item showcase-3">
                <div className="mock-website blue">
                  <div className="mock-header blue"></div>
                  <div className="mock-content">
                    <div className="mock-text-line"></div>
                    <div className="mock-text-line short"></div>
                    <div className="mock-button blue"></div>
                  </div>
                </div>
              </div>
              <div className="showcase-item showcase-4">
                <div className="mock-website">
                  <div className="mock-header"></div>
                  <div className="mock-content">
                    <div className="mock-text-line"></div>
                    <div className="mock-text-line short"></div>
                    <div className="mock-button"></div>
                  </div>
                </div>
              </div>
              <div className="showcase-item showcase-5">
                <div className="mock-website green">
                  <div className="mock-header green"></div>
                  <div className="mock-content">
                    <div className="mock-text-line"></div>
                    <div className="mock-text-line short"></div>
                    <div className="mock-button green"></div>
                  </div>
                </div>
              </div>
              <div className="showcase-item showcase-6">
                <div className="mock-website">
                  <div className="mock-header"></div>
                  <div className="mock-content">
                    <div className="mock-text-line"></div>
                    <div className="mock-text-line short"></div>
                    <div className="mock-button"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <AnimatedSection animationType="fadeInUp">
            <h2>Discover our services</h2>
          </AnimatedSection>
          <AnimatedSection animationType="fadeInUp" delay={200}>
            <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🎯</div>
              <h3>Reach</h3>
              <p>Reach more customers with a modern, sleek looking website that uses SEO techniques to put your business at the forefront.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">🛒</div>
              <h3>Sell</h3>
              <p>Sell more products with a website catered to commerce and built to streamline the shopping experience for your customer.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">⚙️</div>
              <h3>Operate</h3>
              <p>Operate your business at the next level with a fully functional web application that you can use to store, analyze, and retrieve your data efficiently.</p>
            </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="timeline">
        <div className="container">
          <AnimatedSection animationType="fadeInUp">
            <h2>Our Process</h2>
          </AnimatedSection>
          <AnimatedSection animationType="fadeInUp" delay={200}>
            <div className="timeline-container">
            <div className="timeline-item right">
              <div className="timeline-content">
                <h3>Initial Consultation</h3>
                <p>We discuss your vision, goals, and requirements.</p>
              </div>
              <div className="timeline-dot"></div>
            </div>
            <div className="timeline-item left">
              <div className="timeline-content">
                <h3>Design Phase</h3>
                <p>We create mockups and wireframes for your approval.</p>
              </div>
              <div className="timeline-dot"></div>
            </div>
            <div className="timeline-item right">
              <div className="timeline-content">
                <h3>Development</h3>
                <p>We build your website using modern technologies.</p>
              </div>
              <div className="timeline-dot"></div>
            </div>
            <div className="timeline-item left">
              <div className="timeline-content">
                <h3>Testing & Review</h3>
                <p>We ensure everything works perfectly.</p>
              </div>
              <div className="timeline-dot"></div>
            </div>
            <div className="timeline-item right">
              <div className="timeline-content">
                <h3>Launch</h3>
                <p>Your website goes live to the world.</p>
              </div>
              <div className="timeline-dot"></div>
            </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing">
        <div className="container">
          <AnimatedSection animationType="fadeInUp">
            <h2>Pricing</h2>
          </AnimatedSection>
          <AnimatedSection animationType="fadeInUp" delay={200}>
            <div className="pricing-grid">
            <div className="pricing-card">
              <h3>Website Development</h3>
              <div className="price">Contact us for Quote</div>
              <p className="price-detail">10% due on agreement, rest due at completion.</p>
              <ul>
                <li>Custom Design</li>
                <li>Responsive Layout</li>
                <li>SEO Optimization</li>
                <li>Contact Forms</li>
                <li>Basic Analytics</li>
              </ul>
            </div>
            <div className="pricing-card">
              <h3>Hosting & Maintenance</h3>
              <div className="price">Starting at $5/month</div>
              <p className="price-detail">Keep your website running smoothly with our hosting service.</p>
              <ul>
                <li>Reliable Hosting</li>
                <li>Regular Updates</li>
                <li>Security Monitoring</li>
                <li>Backup Services</li>
                <li>Technical Support</li>
              </ul>
            </div>
          </div>
          </AnimatedSection>
          <AnimatedSection animationType="fadeInUp" delay={400}>
            <div className="pricing-cta">
              <Link to="/contact" className="cta-button">Get Your Quote</Link>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>
  );
};

export default Home; 